import placeholderProfileImage from 'assets/icons/placeholder-profile.svg?inline';
import styled from 'styled-components';

import { imageSize } from '../../lib/common';

interface ImageProps {
  size?: number;
}

export const DefaultImage = styled.img.attrs({
  alt: 'Person Avatar',
  src: placeholderProfileImage
})<ImageProps>`
  ${props => imageSize(props.size)}
  display: block;
`;

export const UserImage = styled.img<ImageProps>`
  ${props => imageSize(props.size)}
  border-radius: 50%;
`;
